import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const data = {
  personaNatural: {
      id: 0,
      nombres: "",
      fechaIngreso: "",
      esEmpresa: false,
      primerNombre: "",
      segundoNombre: "",
      primerApellido: "",
      segundoApellido: "",
      fechaNacimiento: "",
      idPais: 0,
      pais: "",
      idDepartamento: 0,
      departamento: "",
      idProvincia: 0,
      provincia: "",
      idUbigeoNacimiento: 0,
      ubigeoNacimiento: "",
      idSexo: 0,
      sexo: "",
      idEstadoCivil: 0,
      estadoCivil: "",
      idTipoPersona: 0,
      tipoPersona: "",
      idOcupacion: 0,
      ocupacion: "",
      idLugarTrabajo: 0,
      lugarTrabajo: "",
      idEstado: 0,
      fechaRegistro: null,
      usuarioRegistro: null,
      fechaModificacion: null,
      usuarioModificacion: null,
  },
  sexos: [{ id: 0, descripcion: "" }],
  estadosCiviles: [{ id: 0, descripcion: "" }],
  tiposPersona: [{ id: 0, descripcion: "" }],
  ocupaciones: [{ id: 0, descripcion: "" }],
  lugaresTrabajo: [{ id: 0, descripcion: "" }],
  validationActive: {
      primerNombre: false,
      primerApellido: false,
      idSexo: false,
      idEstadoCivil: false,
      idTipoPersona: false,
      fechaIngreso: false,
      fechaNacimiento: false,
  },
  validationMessage: [],
  personList: {
    id: 0,
    nombres: "",
  },
  tipoPersona: "",
  nombreVinculado: "",
}

export const personSlice = createSlice({
  name: "person",
  initialState: {},
  reducers: {
    initPerson: (state, action) => {
      const { sliceKey } = action.payload;
      // if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
      if (!state[sliceKey]) state[sliceKey] = structuredClone(data);
    },
    setPersonaNatural: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].personaNatural = data;
    },
    setDatoPersonaNatural: (state, action) => {
      var { sliceKey, name, value } = action.payload;

      if (name.startsWith("id")) value = parseInt(value)
      
      state[sliceKey].personaNatural[name] = value
      state[sliceKey].validationActive[name] = true
    },
    setSexos: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].sexos = data;
    },
    setEstadosCiviles: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].estadosCiviles = data;
    },
    setTiposPersona: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].tiposPersona = data;
    },
    setOcupaciones: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].ocupaciones = data;
    },
    setLugaresTrabajo: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].lugaresTrabajo = data;
    },
    setValidations: (state, action) => {
      const {sliceKey, message} = action.payload;
      state[sliceKey].validationMessage = message;
    },
    activeValidationsPersonaNatural: (state, action) => {
      const {sliceKey} = action.payload;
      Object.keys(state[sliceKey].validationActive).forEach(function (key) {
        state[sliceKey].validationActive[key] = true;
      })
    },
    setPersonList: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].personList = data;
    },
    setTipoPersona: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].tipoPersona = data || "";
    },
    setNombreVinculado: (state, action) => {
      const {sliceKey, name} = action.payload;
      state[sliceKey].nombreVinculado = name;
    },
  },
});

export const { initPerson, setPersonaNatural, setDatoPersonaNatural, setSexos, setEstadosCiviles, setTiposPersona, setOcupaciones, setLugaresTrabajo
  , setValidations, activeValidationsPersonaNatural, setPersonList
  , setNombreVinculado, setTipoPersona, setTipoVinculo } = personSlice.actions;
export const defaultPersonaNatural = {
  id: 0,
  nombres: "",
  fechaIngreso: moment().format('yyyy-MM-DD'),
  esEmpresa: false,
  primerNombre: "",
  segundoNombre: "",
  primerApellido: "",
  segundoApellido: "",
  fechaNacimiento: moment("2000-01-01").format('yyyy-MM-DD'),
  idPais: 0,
  pais: "",
  idDepartamento: 0,
  departamento: "",
  idProvincia: 0,
  provincia: "",
  idUbigeoNacimiento: 230101,
  ubigeoNacimiento: "TACNA",
  idSexo: 33,
  sexo: "Masculino",
  idEstadoCivil: 36,
  estadoCivil: "Soltero",
  idTipoPersona: 23,
  tipoPersona: "Padre",
  idOcupacion: 0,
  ocupacion: "",
  idLugarTrabajo: 0,
  lugarTrabajo: "",
  idEstado: 2,
  fechaRegistro: null,
  usuarioRegistro: null,
  fechaModificacion: null,
  usuarioModificacion: null,
}
export default personSlice.reducer;
